// extracted by mini-css-extract-plugin
export default {"container":"Contact_container__Fgi1R","body":"Contact_body__XDZa6","formControlLabel":"Contact_formControlLabel__uCgLH","checkboxLabel":"Contact_checkboxLabel__kCfe+"};